import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GlobalsService } from "../../globals.service";
import { ReportMacro } from "../../macros/shared/macro.model";
import { Template } from "./template.model";
import { TemplateHtml } from "./template-html.model";

@Injectable({ providedIn: "root" })
export class TemplateService {
  public dataSource: MatTableDataSource<Template>;
  public executiveSummaryTemplate: Template;
  public selectedTemplate: Template;
  public templateList: Template[];
  public templateHtmls: TemplateHtml[] = [];

  public constructor(
    private http: HttpClient,
    private globalsService: GlobalsService,
  ) {
    this.selectedTemplate = new Template();
    /*
    this.getTemplateList().then(templateList => {
      this.templateList = templateList;
    });
    */
  }

  public addTemplateHtml(code: string, html: string) {
    const templateHtml = new TemplateHtml();
    templateHtml.code = code;
    templateHtml.html = html;
    this.templateHtmls.push(templateHtml);
  }

  public setTemplateHtml(code: string, html: string) {
    var templateHtmls = this.templateHtmls.filter((p) => p.code === code);
    templateHtmls[0].html = html;
  }

  public getTemplateHtmlByCode(code: string): string {
    var templateHtml: string = null;

    var codeTemplateHtmls = this.templateHtmls.filter((p) => p.code === code);
    if (codeTemplateHtmls.length > 0) {
      templateHtml = codeTemplateHtmls[0].html;
    } else {
      this.addTemplateHtml(code, ""); //adds empty html so repeated calls pick up it being there prior to the promise returning

      this.getTemplateHtmlPromiseByCode(code).then((result) => {
        templateHtml = result.html;
        this.setTemplateHtml(code, templateHtml);
      });
    }

    return templateHtml;
  }

  public bumpIteration(
    datasetID: number,
    respondentID: number,
  ): Promise<boolean> {
    // const respondentID = this.globalsService.getActiveRespondentID();
    const path = `dataset/iteration/bump?datasetID=${datasetID}&respondentID=${respondentID}`;
    return this.http.get<boolean>(path).toPromise();
  }

  public deleteTemplate(id: number): Promise<Template> {
    return this.http.delete<Template>(`template/${id}`).toPromise();
  }

  public getExecutiveSummaryTemplateID(): Promise<number> {
    const ownerID = this.globalsService.getOwnerID();
    return this.http
      .get<number>(`template/summary/owner/${ownerID}`)
      .toPromise();
  }

  public getReportTemplateChunks(id: number): Promise<any> {
    return this.http.get<any>(`template/chunks/${id}`).toPromise();
  }

  public getTemplate(id: number): Promise<Template> {
    return this.http.get<Template>(`template/${id}`).toPromise();
  }

  public getTemplateHtmlPromiseByCode(
    code: string,
    macros: ReportMacro[] = null,
  ): Promise<any> {
    if (!macros) {
      macros = [];
    }

    const body = JSON.stringify(macros);
    return this.http
      .post<any>(
        `template/code/html?` +
          `code=${code}&simple=${this.globalsService.isSimple()}`,
        body,
      )
      .toPromise();
  }

  public getTemplateHtml(
    id: number,
    datasetExternalID: number,
    respondentExternalID: number,
    macros: ReportMacro[],
    processGUID: string = null,
  ): Promise<any> {
    if (!macros) {
      macros = [];
    }

    const body = JSON.stringify(macros);

    var path =
      `template/${id}/html?` +
      `&datasetExternalID=${datasetExternalID}` +
      `&respondentExternalID=${respondentExternalID}`;

    if (processGUID != null) {
      path += `&processGuid=${processGUID}`;
    }

    return this.http.post<any>(path, body).toPromise();
  }

  public getTemplateList(ownerID: number = null): Promise<Template[]> {
    var oid = ownerID == null ? this.globalsService.getOwnerID() : ownerID;

    return this.http.get<Template[]>(`template/list/${oid}`).toPromise();
  }

  public postTemplate(template: Template) {
    template.id = 0;
    template.designerID = undefined;
    template.ownerID = this.globalsService.getOwnerID();
    template.ownerDesignerID = this.globalsService.getOwnerDesignerID();
    const body = JSON.stringify(template);
    return this.http.post("template", body).toPromise();
  }

  public putTemplate(template): Promise<Template> {
    template.ownerID = this.globalsService.getOwnerID();
    template.ownerDesignerID = this.globalsService.getOwnerDesignerID();
    const body = JSON.stringify(template);
    return this.http.put<Template>("template", body).toPromise();
  }

  public refresh() {
    this.getTemplateList().then((x) => {
      this.dataSource.data = x;
    });
  }
}
